import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { ParagraphContainer } from '@hellodarwin/core/lib/components/common/typography/styles';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import ArrowOutline from '@hellodarwin/icons/dist/icons/ArrowOutline';
import Sider from 'antd/es/layout/Sider';
import styled, { css, keyframes } from 'styled-components';
export const AssistantSiderContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-right: none;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  height: 100%;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;

  ${({ $collapsed }) => $collapsed
    ? css `
          ${AssistantDrawerTitle},${AssistantSiderConversationsContainer} {
            display: none;
            opacity: 0;
          }
        `
    : css `
          ${AssistantDrawerTitle},${AssistantSiderConversationsContainer} {
            animation: ${appear} 0.3s ease;
          }
        `}
`;
export const AssistantSiderConversationsContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
  min-width: 0;
  flex: 1;
  min-height: 0;

  overflow-y: auto;
  padding-right: ${({ theme }) => theme.spacing.xs}px;
`;
export const AssistantConversationsList = styled.div `
  overflow: auto;
  min-height: 0;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const AssistantSiderLinkContainer = styled(Button) `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding-inline: ${({ theme }) => theme.spacing.md}px;
  padding-block: ${({ theme }) => theme.spacing.sm}px;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colors.grey_1};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  width: 100%;
  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.purple_5};
    filter: none;
  }
`;
export const AssistantSiderCollapsedActionStack = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const AssistantSiderLinkCountBadge = styled.span `
  min-width: ${({ theme }) => theme.spacing.xl}px;
  height: ${({ theme }) => theme.spacing.lg}px;
  padding-inline: ${({ theme }) => theme.spacing.sm}px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.border_radius.full};
  border: 1px solid ${({ theme }) => theme.colors.purple_3};
  background: ${({ theme }) => theme.colors.purple_5};
  color: ${({ theme }) => theme.colors.purple_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  font-size: ${({ theme }) => theme.fonts.body4};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.body4}px;
  line-height: ${({ theme }) => theme.fontsLineHeights.body4};
`;
export const AssistantSiderSpacing = styled.hr `
  margin-block: ${({ theme }) => theme.spacing.sm}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_5};
  width: auto;
  margin-inline: 0;
`;
export const AssistantSiderStyled = styled(Sider) `
  position: relative;
  .ant-layout-sider-trigger {
    position: absolute;
    top: 0;
    z-index: 1100;
    background-color: transparent !important;
    color: white;
    width: fit-content !important;
    height: 100%;
    cursor: pointer;
    right: ${({ theme }) => -theme.spacing.sm}px;
  }
  ${AssistantSiderLinkContainer} {
    ${({ collapsed }) => collapsed &&
    css `
        justify-content: center;
        align-items: center;
        gap: 0;
        width: fit-content;
        margin-inline: auto;
        padding-inline: 0;
        padding-block: 0;

        > span:last-of-type {
          display: none;
        }
      `}

    ${ParagraphContainer} {
      ${({ collapsed }) => collapsed
    ? css `
              display: none;
              opacity: 0;
            `
    : css `
              animation: ${appear} 0.3s ease;
            `}
    }
  }
`;
export const AssistantDrawerTitle = styled(Typography) `
  display: block;
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  text-align: left;
  line-height: 1.2;
  ${media.tablet `
    line-height:1.2;
    `}
`;
export const AssistantSiderHeaderContent = styled.div `
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  column-gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const AssistantSiderHeaderActions = styled.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  flex-shrink: 0;
`;
export const AssistantSiderHeaderActionButton = styled(Button) `
  flex-shrink: 0;
`;
const appear = keyframes `
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity:1;
  }
`;
export const AssistantTriggerStyled = styled.div `
  border-radius: ${({ theme }) => theme.border_radius.full};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow_high_contrast};

  z-index: 1000;
  position: sticky;
  top: ${({ theme }) => theme.appearance.appHeaderHeight}px;
  width: fit-content;
  height: fit-content;
  width: ${({ theme }) => theme.spacing.lg}px;
  height: ${({ theme }) => theme.spacing.lg}px;
  padding: 0;
  display: flex;
`;
export const AssistantArrowOutlineStyled = styled(ArrowOutline) `
  color: ${({ theme }) => theme.colors.grey_3};
  .background {
    fill: ${({ theme }) => theme.colors.grey_5};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.white_1};
    .background {
      fill: ${({ theme }) => theme.colors.grey_4};
    }
  }
`;
export const AssistantSiderBody = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0px;
  overflow: hidden;
`;
export const AssistantSiderCollapsedContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
`;
